import { formatPhone } from "./phone-format.js";
/**
 * Os dados do cliente, prontos para o papel — F160.
 *
 * Uma função para os quatro lugares que imprimem um documento de venda: o
 * orçamento, o recibo do PDV e a reimpressão de venda e de pedido. Cada um
 * decidindo sozinho, o mesmo cliente sairia com o telefone formatado num papel
 * e só com dígitos no outro.
 *
 * `undefined` para o Consumidor Final e para quem o servidor não mandou: o papel
 * sai sem linha de cliente nenhuma, e nunca com "Endereço: —".
 */
export const printedCustomerOf = (document) => {
    /*
     * `== null`, e não `=== null`: cobre também o campo AUSENTE. O contrato o
     * preenche com nulo na fronteira, mas há caminhos que montam o documento sem
     * passar por ela — o PDV offline e as telas de teste — e o papel não pode
     * quebrar por causa de um endereço que ele nem é obrigado a ter.
     */
    const contact = document.customerContact;
    if (contact == null)
        return undefined;
    const parts = contact.addressParts;
    const cep = parts?.postalCode == null || parts.postalCode.trim() === ''
        ? null
        : parts.postalCode.replace(/^(\d{5})(\d{3})$/, '$1-$2');
    const cityState = parts == null
        ? null
        : [parts.city, parts.state]
            .filter((part) => part !== null && part.trim() !== '')
            .join(' - ') || null;
    return {
        document: contact.document,
        phone: contact.phone === null ? null : formatPhone(contact.phone),
        address: contact.address,
        email: contact.email,
        /*
         * F161 — o papel do sistema antigo: o código, cada telefone com o seu
         * nome, e o endereço campo a campo. O modelo da nota decide o que sai.
         */
        code: contact.code,
        phones: contact.phones.map((entry) => ({
            label: PHONE_LABEL[entry.kind],
            value: formatPhone(entry.value),
        })),
        addressParts: parts == null
            ? undefined
            : {
                street: parts.street,
                number: parts.number,
                district: parts.district,
                complement: parts.complement,
                postalCode: cep,
                cityState,
            },
    };
};
const PHONE_LABEL = {
    whatsapp: 'WhatsApp',
    mobile: 'Celular',
    phone: 'Telefone',
};
//# sourceMappingURL=printed-customer.js.map